/* eslint-disable @typescript-eslint/no-explicit-any */

interface SelectButtonProps {
    value: any,
    items: { value: any, label: string, counter?: number }[],
    disabled?: boolean,
    onChange?: (value: any) => void
}

export function SelectButton({ value, items, onChange, disabled }: SelectButtonProps) {
    return (
        <ul className="form__radio-list">
            {items.map(item => {
                return <li key={item.value}>
                    <label className={'radio' + (value === item.value ? ' radio-checked' : '')}>
                        <input
                            type="radio"
                            name="user-lang"
                            value={item.value}
                            onClick={() => {
                                if (disabled) return;
                                onChange && onChange(item.value);
                            }}
                        />{item.label}
                        {!!item.counter && <span className="label-bubble main__types-item-label">{item.counter}</span>}
                    </label>
                </li>
            })}
        </ul>
    );
}